import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Carousel,
  CarouselItem,
  CarouselControl,
  Button,
} from 'reactstrap';
import classNames from 'classnames';
import JSZip from 'jszip';
import { FooterButtons } from '../../../shared/components/Modals/FooterButtons';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

export default function ModalPdfViewer({ dataPdf = [], isOpen, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const [animating, setAnimating] = useState(false);

  const currentPdf = dataPdf[currentIndex];

  const next = () => {
    if (animating) return;
    setCurrentIndex(currentIndex === dataPdf.length - 1 ? 0 : currentIndex + 1);
  };

  const previous = () => {
    if (animating) return;
    setCurrentIndex(currentIndex === 0 ? dataPdf.length - 1 : currentIndex - 1);
  };

  const downloadFile = (url, name) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = name || 'document.pdf';
    a.click();
  };

  const downloadFilesAsZip = async (urls, zipName = 'files.zip') => {
    const zip = new JSZip();

    await Promise.all(
      urls.map(async (url) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();

          const urlParts = url.split('/');
          let filename = urlParts[urlParts.length - 1];
          if (!filename) {
            filename = `file_${Math.random().toString(36).substring(2, 8)}.bin`;
          }

          zip.file(filename, blob);
        } catch (e) {
          console.error('Error loading file:', url, e);
        }
      }),
    );

    const content = await zip.generateAsync({ type: 'blob' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(content);
    a.download = zipName;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <Modal
      isOpen={isOpen}
      size="md"
      backdrop="static"
      className="model-form nested-modal modal-pdf-viewer "
    >
      <ModalHeader>PDF Viewer</ModalHeader>
      <ModalBody className={classNames({ 'non-files': dataPdf.length === 0 })}>
        <div className="pdf-preview border rounded shadow">
          <a href={currentPdf} target="_blank" rel="noopener noreferrer">
            <Document file={currentPdf}>
              <Page
                pageNumber={1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                width={204}
                height={264}
              />
            </Document>
          </a>
        </div>

        {dataPdf.length !== 0 && (
          <>
            <div className="carousel-wrapper">
              <Carousel
                activeIndex={Math.floor(currentIndex / 3)}
                next={next}
                previous={previous}
                interval={false}
                ride="false"
              >
                {Array.from({ length: Math.ceil(dataPdf.length / 3) }).map(
                  (_, slideIdx) => (
                    <CarouselItem
                      onExiting={() => setAnimating(true)}
                      onExited={() => setAnimating(false)}
                      key={slideIdx}
                    >
                      <div className="carousel-pdf">
                        {dataPdf
                          .slice(slideIdx * 3, slideIdx * 3 + 3)
                          .map((thumbPdf, thumbIndex) => {
                            const globalIndex = slideIdx * 3 + thumbIndex;
                            return (
                              <div
                                key={globalIndex}
                                onClick={() => setCurrentIndex(globalIndex)}
                                className={classNames('carousel-slide', {
                                  active: currentIndex === globalIndex,
                                })}
                              >
                                <Document file={thumbPdf}>
                                  <Page
                                    pageNumber={1}
                                    width={53}
                                    height={68}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                  />
                                </Document>
                              </div>
                            );
                          })}
                      </div>
                    </CarouselItem>
                  ),
                )}
                <CarouselControl
                  direction="prev"
                  directionText="Previous"
                  onClickHandler={previous}
                />
                <CarouselControl
                  direction="next"
                  directionText="Next"
                  onClickHandler={next}
                />
              </Carousel>
            </div>
          </>
        )}
        <FooterButtons
          onClose={onClose}
          showSaveButton={false}
          onSave={undefined}
          additionalButtons={
            <>
              <Button
                color="primary"
                onClick={() => downloadFile(currentPdf)}
                disabled={dataPdf.length === 0}
              >
                Download
              </Button>
              <Button
                color="primary"
                disabled={dataPdf.length === 0}
                onClick={() => downloadFilesAsZip(dataPdf)}
              >
                Download all
              </Button>
            </>
          }
        />
      </ModalBody>
    </Modal>
  );
}
